"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveImageSize = resolveImageSize;

var _find4 = _interopRequireDefault(require("lodash/find"));

var _qs = _interopRequireDefault(require("qs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sizes.
 */
var sizes = [16, 32, 64, 96, 128, 192, 256, 384, 512, 1024];
/**
 * Resolve approximate size.
 */

function resolveApproximateSize() {
  var _find2;

  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return (_find2 = (0, _find4["default"])(sizes, function (size) {
    return size > width;
  })) !== null && _find2 !== void 0 ? _find2 : sizes[sizes.length - 1];
}
/**
 * Resolve mux approximate size.
 */


function resolveMuxApproximateSize() {
  var _find3;

  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var muxSizes = [16, 32, 64, 96, 128, 192, 256, 384, 512, 640];
  return (_find3 = (0, _find4["default"])(muxSizes, function (size) {
    return size > width;
  })) !== null && _find3 !== void 0 ? _find3 : muxSizes[muxSizes.length - 1];
}
/**
 * Image bucket urls.
 */


var imageBucketUrls = [{
  hostname: 'https://d1e2v2u8j6vuez.cloudfront.net',
  resolveSize: resolveApproximateSize,
  widthFormatter: function widthFormatter(width) {
    return {
      size: "".concat(width, "x")
    };
  }
}, {
  hostname: 'https://image.mux.com',
  resolveSize: resolveMuxApproximateSize,
  widthFormatter: function widthFormatter(width) {
    return {
      width: width
    };
  }
}, {
  hostname: 'https://ik.imagekit.io',
  resolveSize: resolveApproximateSize,
  widthFormatter: function widthFormatter(width) {
    return {
      tr: "n-w".concat(width)
    };
  }
}];
/**
 * Get hostname config by uri.
 */

function getHostnameConfigByUri(uri) {
  return (0, _find4["default"])(imageBucketUrls, function (_ref) {
    var hostname = _ref.hostname;
    return uri.startsWith(hostname);
  });
}
/**
 * Export `resolveImageSize`.
 */


function resolveImageSize(imageUrl, size) {
  if (!imageUrl) {
    return imageUrl;
  }

  var hostnameConfig = getHostnameConfigByUri(imageUrl);

  if (!hostnameConfig) {
    return imageUrl;
  }

  var url = new URL(imageUrl);

  if (!url.hostname || !url.protocol) {
    return imageUrl;
  }

  var resolveSize = hostnameConfig.resolveSize,
      widthFormatter = hostnameConfig.widthFormatter;
  url.search = _qs["default"].stringify(_objectSpread(_objectSpread({}, _qs["default"].parse(url.search, {
    ignoreQueryPrefix: true
  })), widthFormatter(resolveSize(parseInt(size, 10)))));
  return url.toString();
}